import nl2br from 'react-nl2br';
import { FollowOperationLocation } from '~/common/types/follow';
import type { UserOverview } from '~/common/types/user-overview';
import { UserThumbnailWithNameAndBadges } from '@app/_components/user-thumbnail-with-name-and-badges';
import { FollowUnfollowButtonContainer } from '@app/_containers/follow-unfollow-button-container';
import { css } from '@styled-system/css';
import { HStack, VStack, Box, Paragraph } from '@styled-system/jsx';
import { useLocalHooks } from './use-local-hooks';

type Props = {
  user: UserOverview;
};

export const UserFollowItem = ({ user }: Props) => {
  const { followersCount, onFollowSucceed, onUnfollowSucceed } =
    useLocalHooks(user);

  const storyCount = user.searchableStoryCount || 0;

  return (
    <HStack
      width="100%"
      padding="16px"
      borderRadius="8px"
      className={css({
        _hover: {
          cursor: 'pointer',
          backgroundColor: 'token(colors.strong_bg)',
        },
      })}
    >
      <VStack>
        <Box width="100%">
          <UserThumbnailWithNameAndBadges
            userId={user.id}
            username={user.name}
            isOfficialWriter={user.isOfficialWriter}
            isVip={user.isVip}
            thumbnail={user.thumbnailUrl || undefined}
            type="large"
            nofollow={storyCount === 0}
          />
        </Box>
        <HStack width="100%" alignItems="flex-start">
          <Box fontSize="size_10" color="accent.700">
            フォロワー
            <Paragraph display="inline-block" marginLeft="4px">
              {followersCount}
            </Paragraph>
          </Box>
          <Box fontSize="size_10" color="accent.700">
            ストーリー
            <Paragraph display="inline-block" marginLeft="4px">
              {storyCount || 0}
            </Paragraph>
          </Box>
        </HStack>

        <Paragraph
          textAlign="left"
          width="100%"
          fontSize="size_13"
          color="accent.1000"
          lineClamp="3"
          maxLines="3"
          lineHeight="18px"
          maxHeight={{ base: 'auto', lg: '58px' }}
          wordBreak="break-word"
        >
          {nl2br(user.profile)}
        </Paragraph>
      </VStack>
      <FollowUnfollowButtonContainer
        buttonPlacementLocation={FollowOperationLocation.SERIES_DETAIL}
        onFollow={onFollowSucceed}
        onUnfollow={onUnfollowSucceed}
        user={user}
        smallRightAligned
      />
    </HStack>
  );
};
